import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Card, Form, Modal, Table } from '@themesberg/react-bootstrap';
import axiosInstance from "../../../api/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Ranked from "../Ciem/Ranked";
import CardLayout from "../Layout/CardLayout";

const TeamList = ({ ciemId }) => {
    const [datos, setDatos] = useState([]);
    const [titulos, setTitulos] = useState([]);
    const [tituloEmprendedor, setTituloEmprendedor] = useState([]);
    const [rankedForm, setRankedForm] = useState([]);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        numero: '',
        nombreCompleto: '',
        direccion: '',
        email: '',
        telefono: '',
        cedula: '',
        profesion: '',
        experiencia: '',
        funcion: '',
        codigo: '',
    });
    const [showModalInformacion, setShowModalInformacion] = useState(false);
    const [modalContentInformacion, setModalContentInformacion] = useState('');

    const handleShowModalInformacion = (content) => {
        setModalContentInformacion(content);
        setShowModalInformacion(true);
    };

    const handleCloseModalInformacion = () => setShowModalInformacion(false);

    const fetchData = async () => {
        try {
            const datosResponse = await axiosInstance.get('/team/' + ciemId); // Reemplaza con la URL de tu API de datos
            setDatos(datosResponse.data.data);

            const titulosResponse = await axiosInstance.get('/detailoption/option/value/teamTable'); // Reemplaza con la URL de tu API de títulos
            setTitulos(titulosResponse.data.data); // Asume que la API de títulos devuelve un array con un objeto y extrae las claves como títulos

            const tituloEmprendedorResponse = await axiosInstance.get('/detailoption/option/value/equipoEmprendedor'); // Reemplaza con la URL de tu API de datos
            setTituloEmprendedor(tituloEmprendedorResponse.data.data);

            const ranked = await axiosInstance.get('/detailoption/option/value/ranked'); // Reemplaza con la URL de tu API de títulos
            const primerElemento = ranked.data;
            console.log("calificacion")
            console.log(primerElemento.data[0])// Asume que la API de títulos devuelve un array con un objeto y extrae las claves como títulos
            setRankedForm(primerElemento.data[0]);

        } catch (error) {
            setError(error);
        }
    };

    //console.log(ciemId)
    useEffect(() => {
        fetchData();
    }, []);

    const handleEditar = (item) => {
        setIsEditing(true);
        setFormData(item);
        setShowModal(true);
    };

    const handleCrearNuevo = () => {
        setIsEditing(false);
        setFormData({
            id: '',
            numero: '',
            nombreCompleto: '',
            direccion: '',
            email: '',
            telefono: '',
            cedula: '',
            profesion: '',
            experiencia: '',
            funcion: '',
            codigo: '',
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleInputChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isEditing) {
            // Lógica para guardar los cambios en la API
            console.log('Guardar cambios:', formData);
            axiosInstance.post('/team/', formData).then(response => {
                alert("Datos actualizados correctamente");
                //setLoading(false);
                // Actualizar el estado del componente con los datos actualizados
                fetchData();
            }).catch(error => {
                alert("Ocurrio el siguiente error -> " + error.response.data.message);
                console.error('Error guardando data:', error.response.data.message);
                //setLoading(false);
            });
        } else {
            // Lógica para crear un nuevo elemento en la API
            console.log('Crear nuevo elemento:', formData);
            const dataToSend = {
                ...formData,
                ciemId: ciemId
            };
            axiosInstance.post('/team/', dataToSend).then(response => {
                alert("Datos guardados correctamente");
                // Actualizar el estado del componente con los datos actualizados
                fetchData();
            }).catch(error => {
                alert("Ocurrió el siguiente error -> " + error.response.data.message);
                console.error('Error guardando data:', error.response.data.message);
            });
        }
        setShowModal(false);
    };


    const handleEliminar = (id) => {
        if (!window.confirm('¿Está seguro de que desea eliminar este registro?')) return;
        axiosInstance.delete(`/team/${id}`)
            .then(() => {
                alert('Registro eliminado correctamente');
                fetchData();
            })
            .catch(error => {
                const msg = error.response?.data?.message || error.message;
                alert('Error al eliminar: ' + msg);
                console.error('Error eliminando team:', msg);
            });
    };


    if (error) {
        return <div>Error: {error.message}</div>;
    }

    if (!datos || !titulos) {
        return <div>Cargando...</div>;
    }

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId} />

    return (
        <div>
            {tituloEmprendedor.map((itemE) => (
                <Card key={itemE.id}>

                    <Card.Header>
                        {/* Título con botón ℹ️ si hay tooltip */}
                        {itemE.description && (
                            <h1>
                                <Card.Title className="d-flex align-items-center gap-2">
                                    {itemE.description}
                                    {itemE.tooltip && (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="p-0 text-info"
                                            onClick={() => handleShowModalInformacion(itemE.tooltip)}
                                            title="Ver información"
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </Button>
                                    )}
                                    {itemE.modal && (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="p-0 ms-1"
                                            onClick={() => handleShowModalInformacion(itemE.modal)}
                                        >
                                            Más información
                                        </Button>
                                    )}
                                </Card.Title>
                            </h1>
                        )}
                    </Card.Header>

                    <Card.Body>
                        <ButtonGroup size="sm">
                            <Button variant="primary" size="sm" onClick={handleCrearNuevo}>Crear Nuevo</Button>{' '}
                        </ButtonGroup>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    {titulos.map((titulo) => (
                                        <th key={titulo.id}>
                                            <span className="d-flex align-items-center gap-1">
                                                {titulo.description}
                                                {titulo.tooltip && (
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="p-0 text-info"
                                                        onClick={() => handleShowModalInformacion(titulo.tooltip)}
                                                        title="Ver información"
                                                    >
                                                        <FontAwesomeIcon icon={faInfoCircle} />
                                                    </Button>
                                                )}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {datos.map((item) => (
                                    <tr key={item.id}>
                                        {titulos.map((titulo) => (
                                            <td key={titulo.id}>{item[titulo.value]}</td>
                                        ))}
                                        <td>
                                            <ButtonGroup size="sm">
                                                <Button variant="info" onClick={() => handleEditar(item)}>Editar</Button>{' '}
                                                <Button variant="danger" onClick={() => handleEliminar(item.id)}>Eliminar</Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {/* Modal para editar/crear */}
                        <Modal show={showModal} onHide={handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>{isEditing ? 'Editar' : 'Crear Nuevo'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={handleSubmit}>

                                    {titulos.map((titulo) => (
                                        <Form.Group key={titulo.id} controlId={`form-${titulo.id}`}>
                                            <Form.Label>{titulo.description}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name={titulo.value}
                                                value={formData[titulo.value]}
                                                onChange={handleInputChange}
                                                maxLength="100"
                                            />
                                        </Form.Group>
                                    ))}
                                    <Button type="submit">Guardar</Button>
                                </Form>
                            </Modal.Body>
                        </Modal>

                    </Card.Body>
                </Card>
            ))
            }
            <CardLayout tablaComponent={calificacion} value={"ranked"} />

            {/* Modal de información (tooltip / más información) */}
            <Modal show={showModalInformacion} onHide={handleCloseModalInformacion} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body dangerouslySetInnerHTML={{ __html: modalContentInformacion }} />
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalInformacion}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >

    );
};

export default TeamList;